export const panelTokens = {
  panel: {
    root: {
      background: '{surface.0}',
      borderColor: '{surface.300}',
      borderRadius: '{borderRadius.lg}',
      color: '{text.color}',
      shadow: '0px 1px 5px 0px rgba(53, 67, 88, 0.05)'
    },
    header: {
      padding: '0',
      background: '{surface.0}',
      color: '{text.color}',
      borderWidth: '0',
      borderColor: 'transparent',
      borderRadius: '0'
    },
    toggleableHeader: {
      padding: '0'
    },
    title: {
      fontWeight: '600'
    },
    content: {
      padding: '0'
    },
    footer: {
      padding: '0'
    }
  }
};

export type PanelTokens = typeof panelTokens;
